/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.rubberband

import com.macrofocus.common.properties.Property
import com.macrofocus.common.selection.SingleSelectionEvent
import com.macrofocus.common.selection.SingleSelectionListener
import org.mkui.color.colorOf
import org.mkui.geom.Point2D
import org.mkui.geom.Rectangle
import org.mkui.geom.Rectangle2D
import org.mkui.graphics.AbstractIDrawing
import org.mkui.graphics.IGraphics
import org.mkui.graphics.colortheme.ColorTheme

/**
 * Created by luc on 27/07/16.
 */
abstract class RubberbandDrawing(rubberband: RubberBand) : AbstractIDrawing() {
    private val rubberband: RubberBand
    val rubberbandListener: SingleSelectionListener<Rectangle2D?> = object : SingleSelectionListener<Rectangle2D?> {
        override fun selectionChanged(event: SingleSelectionEvent<Rectangle2D?>) {
            notifyIDrawingChanged()
        }
    }
    protected abstract val colorTheme: Property<ColorTheme>
    override val isActive: Boolean
        get() = rubberband.rubberBand.isActive && rubberband.rubberBand.selected!!.width != 0.0 && rubberband.rubberBand.selected!!.height != 0.0

    override fun draw(g: IGraphics, point: Point2D?, width: Double, height: Double, clipBounds: Rectangle) {
        val dashPattern = floatArrayOf(10f, 2f, 2f, 2f)
        g.setLineWidth(rubberbandStroke)
        g.setLineDash(dashPattern)
        if (colorTheme.value.isDark) {
            g.setColor(colorOf(255, 255, 255, 220))
        } else {
            g.setColor(colorOf(0, 0, 0, 220))
        }
        g.drawShape(rubberband.rubberBandScreen!!)
    }

    companion object {
        private const val rubberbandStroke = 1.0
    }

    init {
        this.rubberband = rubberband
        rubberband.rubberBand.addSingleSelectionListener(rubberbandListener)
    }
}